import React from "react";
import { Global } from "@emotion/core";
import { ApolloProvider } from "@apollo/react-hooks";
import client from "apollo";
import { Reset } from "styles";
import App, { urlLangCheck } from "components/App";

const Root: React.FC = () => {
  urlLangCheck();
  return (
    <>
      <Global styles={Reset} />
      <ApolloProvider client={client as any}>
        <App />
      </ApolloProvider>
    </>
  );
};

export default Root;
